module.exports = __webpack_public_path__ + "static/media/close-btn.02763aaa.svg";